import { useState } from 'react';
import { useAppDispatch } from '../../../../../store/hook';
import {
  openAlert,
  openConfirm,
} from '../../../../../store/features/modalSlice';
import { AssignmentItem } from '../../../../../constants/types/lms/assignment/type';
import {
  openTodoView,
  resolveJebsplayerUrl,
} from '../../../../../util/openContentsWindow';

/**
 * 과제 선택 패널의 교사용 미리보기(onPreviewClick) 로직 공통 훅
 * @description
 * - 미리보기 확인 모달을 띄우고, 확인 시 젭스플레이어 콘텐츠 창을 오픈합니다.
 * - 기존 Actual Test/Daily Test → 별도 TestView 창 분기는 신규 젭스플레이어 개발에 따라 제거되었습니다.
 */
export const useAssignmentPreview = () => {
  const dispatch = useAppDispatch();
  const setTodoView = useState<Window>(undefined)[1];

  const onPreviewClick = (assignment: AssignmentItem) => {
    dispatch(
      openConfirm({
        message: (
          <div className="flex flex-col gap-5 text-center md:my-3">
            <div className="text-2xl font-bold">
              결과가 반영되지 않는 <br />
              교사용 미리보기 화면입니다
            </div>
            <div className="text-base">
              학생 과제는 학생 계정을 통해 진행해주세요.
            </div>
          </div>
        ),
        confirmText: '보기',
        cancelText: '닫기',
        onConfirm: () => {
          if (!assignment.link) {
            dispatch(
              openAlert({
                message: '미리보기 링크가 없습니다. 관리자에게 문의해주세요.',
              }),
            );
            return;
          }

          openTodoView(
            { url: resolveJebsplayerUrl(assignment.link) },
            setTodoView,
          );
        },
      }),
    );
  };

  return { onPreviewClick };
};
